import './BlogListSkeleton.scss';

const BlogListSkeleton = () => {

    return (
        <div className="blog__list__skeleton">
            <div className="blog__filters__skeleton">
                <div className="categories__skeleton">
                    {[...Array(6)].map((_, index) => (
                        <div key={index} className="category__link__skeleton" />
                    ))}
                    <div className="search__button__skeleton"></div>
                </div>
            </div>
            <div className="articles__skeleton">
                <div className="article__grid__skeleton">
                    {[...Array(6)].map((_, index) => (
                        <div key={index} className="article__card__skeleton">
                            <div className='article__link__skeleton'>
                                <div className="article__image__skeleton"></div>
                                <div className="article__info__skeleton">
                                    <div className="article__date__skeleton"></div>
                                    {[...Array(2)].map((_, index) => (
                                        <div key={index} className="article__title__skeleton" />
                                    ))}
                                    <div className="article__title__skeleton--primary"></div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BlogListSkeleton;